import { createContext } from 'react'
import { Analytics } from '.'

const noopAnalytics: Analytics = {
  dataLayer: () => undefined,
}

const AnalyticsContext = createContext<Analytics>(noopAnalytics)

export default AnalyticsContext
